import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Icon, Tooltip } from '@fiverr-private/fit';
import { logger } from '@fiverr-private/obs';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { isMobileView } from '../../utils/general';
import classes from './style.module.scss';

const CountryFlag = ({ countryCode }) => {
    const [flag, setFlag] = useState(null);
    const countryIsValid = countryCode && typeof countryCode === 'string';

    useEffect(() => {
        const importFlag = async() => {
            if (countryIsValid) {
                try {
                    const { [countryCode.toLowerCase()]: importedFlag } = await import(/* webpackChunkName: 'flags' */'@fiverr-private/fit/icons/flags');

                    if (importedFlag) {
                        setFlag(importedFlag);
                    }
                } catch (error) {
                    error.description = `Failed to load the the seller country flag: ${countryCode}`;
                    logger.warn(error);
                }
            }
        };

        importFlag();
    }, [countryCode, countryIsValid]);

    const countryFlagClassName = classNames(
        classes.fmpCountryFlagContainer,
        'flex m-l-8',
        { [classes.isMobile]: isMobileView() });

    return flag ? (
        <div data-testid="country-flag-icon" className={countryFlagClassName}>
            <Tooltip boxContentClassName={classes.fmpFlagTooltipOpen}
                content={
                    <div data-testid="country-flag-tooltip">
                        <I18n k="send_message.country_flag.seller_location"
                            params={{ countryName: translate(`countries.${countryCode.toUpperCase()}`) }}
                            templates={{
                                'label': (text) => (<strong className={classes.label}>{text}</strong>)
                            }}/>
                    </div>
                }
                appendToBody={false}>
                <div data-testid="flag-icon" className="flex"> <Icon size={20}>{flag}</Icon> </div>
            </Tooltip>
        </div>
    ) : null;
};

CountryFlag.propTypes = {
    countryCode: PropTypes.string
};

export default CountryFlag;
